import { styled } from '@mui/system';

export const Image = styled('img')({});
